import React from "react";
import { useNavigate } from "react-router-dom";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { Trash2, Plus, Minus, ShoppingCart } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { fileUrl, brl } from "@/lib/api";

export default function CartDrawer({ open, onOpenChange }) {
  const { items, updateQty, removeItem, total } = useCart();
  const navigate = useNavigate();

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent data-testid="cart-drawer" className="bg-[var(--bg-card)] border-[var(--border)] text-[var(--text-main)] w-full sm:max-w-md flex flex-col">
        <SheetHeader>
          <SheetTitle className="font-head text-xl flex items-center gap-2">
            <ShoppingCart size={20} /> Seu carrinho
          </SheetTitle>
        </SheetHeader>

        {items.length === 0 ? (
          <div className="flex-1 flex items-center justify-center text-[var(--text-muted)]" data-testid="cart-empty">
            Seu carrinho está vazio.
          </div>
        ) : (
          <>
            <div className="flex-1 overflow-y-auto space-y-4 py-4 no-scrollbar">
              {items.map((it) => (
                <div key={`${it.product_id}-${it.size}`} className="flex gap-3 border border-[var(--border)] rounded-xl p-3" data-testid={`cart-item-${it.product_id}-${it.size}`}>
                  <div className="w-16 h-16 rounded-lg overflow-hidden bg-[var(--bg-secondary)] shrink-0">
                    {it.photo ? <img src={fileUrl(it.photo)} alt={it.name} className="w-full h-full object-cover" /> : null}
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="font-semibold text-sm truncate">{it.name}</div>
                    <div className="text-xs text-[var(--text-muted)]">Tamanho: {it.size}</div>
                    <div className="text-sm font-bold text-[var(--accent)] mt-1">{brl(it.price)}</div>
                    <div className="flex items-center gap-2 mt-2">
                      <button onClick={() => updateQty(it.product_id, it.size, it.quantity - 1)} className="p-1 border border-[var(--border)] rounded" data-testid={`cart-dec-${it.product_id}-${it.size}`}><Minus size={14} /></button>
                      <span className="w-6 text-center text-sm">{it.quantity}</span>
                      <button onClick={() => updateQty(it.product_id, it.size, it.quantity + 1)} className="p-1 border border-[var(--border)] rounded" data-testid={`cart-inc-${it.product_id}-${it.size}`}><Plus size={14} /></button>
                    </div>
                  </div>
                  <button onClick={() => removeItem(it.product_id, it.size)} className="text-[var(--text-muted)] hover:text-red-400" data-testid={`cart-remove-${it.product_id}-${it.size}`}><Trash2 size={16} /></button>
                </div>
              ))}
            </div>
            <div className="border-t border-[var(--border)] pt-4 space-y-3">
              <div className="flex justify-between font-bold text-lg">
                <span>Total</span>
                <span className="text-[var(--accent)]">{brl(total)}</span>
              </div>
              <Button onClick={() => { onOpenChange(false); navigate("/pagode-das-cinco-pontas/checkout"); }}
                data-testid="cart-checkout-button" className="w-full btn-primary font-bold h-12">
                Finalizar compra
              </Button>
            </div>
          </>
        )}
      </SheetContent>
    </Sheet>
  );
}
